// col templates - used during dynamic sync col generation
import * as _ from 'lodash';

/* istanbul ignore next */
export const FlattenedStudentMapDynamic = {
  schoolAssessments: {
    fAndP: {
      tag: 'Fountas & Pinnell, Fountas and Pinnell, F&P, F and P, Formative Assessments',
      tags: ['Fountas & Pinnell', 'Fountas and Pinnell', 'F&P', 'F and P', 'Formative Assessments'],
      humanName: 'F and P',
      path: 'join_student_assessments',
      calculation(student) {
        return _.get(student, this.path);
      },
    },
  },
};
